import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from 'react'

import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import axios from "axios";
import Loader from "../../../utils/Loader";
import { Pagination } from "../../helper/HelperTwo";
import PayoutCreate from "./PayoutCreate";
import PayoutEdit from "./PayoutEdit";
import { toast } from "react-toastify";
import { ExclamationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

const PayoutList = () => {

    const [formData, setFormData] = useState([])
    const [payouts, setPayout] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate();
    const [paginationData, setPaginationData] = useState(null);
    const [payoutCreateOpen, setPayoutCreateOpen] = useState(false)
    const [payoutEditOpen, setPayoutEditOpen] = useState(false);
    const [payoutId, setPayoutId] = useState(null)
    const [payoutDelete, setPayoutDelete] = useState(false)
    const [deleteMsg, setDeleteMsg] = useState(
        "Are you sure you want to delete the Payout ?"
    );
    const [payoutFilter, setPayoutFilter] = useState({
        customer_id: "",
        active_plan_id: "",

    })
    const [customerList, setCustomerList] = useState([])
    const [activePlanList, setActivePlan] = useState([])

    const handleClose = async () => {
        setPayoutCreateOpen(false);
        setPayoutEditOpen(false)
        setPayoutDelete(false)
        await fetchData()
    }

    const handleClick = () => {
        setPayoutCreateOpen(true);
    };

    const Delete = (id_crypt) => {
        setPayoutDelete(true);
        setPayoutId(id_crypt);
    };

    const fetchData = async (page = 1) => {
        setLoading(true)
        try {
            const token = localStorage.getItem("token")
            let endpoint = `public/api/customer-payouts?page=${page}`;

            const response = await axios.get(endpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const customerList = await axios.get(`public/api/customers/filter/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const activeplan = await axios.get(`public/api/active/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
           
            setActivePlan(activeplan.data)

            if (customerList.data.success) {
                setCustomerList(customerList.data.data)
            }
            if (response.data.success) {
                setPayout(response?.data?.payout?.data)
                setPaginationData(response?.data?.payout)
            }
           
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const handlePageChange = (page) => {
        if (page !== "...") {
            fetchData(page);

        }
    };

    const handleClickForView = (id) => {
        setPayoutId(id);

        setPayoutEditOpen(true);
    };


    const handleClickForDelete = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.delete(
                `public/api/customer-payouts/${payoutId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            )
            if (response.data) {
                toast.success("payout Deleted successfully!");
                fetchData()
                setPayoutDelete(false)

            }


        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPayoutFilter((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    const handleFilter = async (page = 1) => {
        try {
            setLoading(true)
            const token = localStorage.getItem("token");
            let endpoint = `public/api/customer-payouts`;


            const response = await axios.get(endpoint, {
                params: {
                    page: page,
                    customer_id: payoutFilter.customer_id,
                    active_plan_id: payoutFilter.active_plan_id,

                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });

            if (response.data.success) {
                setPayout(response?.data?.payout?.data)
                setPaginationData(response?.data?.payout)
            }
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const resetFilter = () => {
        setPayoutFilter({
            customer_id: "",
            active_plan_id: "",
           
        })
        fetchData();

    }

    if (loading) {
        return (
            <Loader />
        )
    }

    return (
        <div>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className=" font-semibold text-3xl text-gray-900">Payout</h1>
                        <p className="mt-2 text-sm text-gray-700">
                            Manage all your chit fund Customer and their details..
                        </p>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <button
                            type="button"
                            onClick={handleClick}
                            className="block rounded-md bg-[#0f172a] px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-teal-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
                        >
                            Add Pay Out
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                    {/* Select Plan */}
                    <div>
                        <select
                            id="customer_id"
                            name="customer_id"
                            value={payoutFilter.customer_id}
                            onChange={handleChange}
                            autoComplete="plan_id"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                        >
                            <option value="">Select Customer</option>
                            {customerList?.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                    </div>
{/* 
                    <div>
                        <select
                            id="active_plan_id"
                            name="active_plan_id"
                            value={payoutFilter.active_plan_id}
                            onChange={handleChange}
                            autoComplete="plan_id"
                            className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset 
                 ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
                        >
                            <option value="">Select Active Plan</option>
                           
                                <option  value='inactive'>
                                   Inactive
                                </option>
                                <option  value='active'>
                                   Active
                                </option>
                        
                        </select>
                    </div> */}









                    {/* Filter Button */}
                    <div className="flex items-center">
                        <button
                            className="w-full rounded-md bg-[#0f172a] px-3 py-2 text-sm font-semibold text-white 
                 shadow-sm hover:bg-teal-900 focus-visible:outline-2 
                 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"

                            onClick={() => handleFilter(1)}
                        >
                            Filter
                        </button>
                    </div>

                    {/* Clear Button (optional, for balance) */}
                    <div className="flex items-center">
                        <button
                            className="w-full rounded-md bg-gray-200 px-3 py-2 text-sm font-semibold text-gray-700 
                 shadow-sm hover:bg-gray-300 focus-visible:outline-2 
                 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          onClick={() => resetFilter()}
                        >
                            Clear
                        </button>
                    </div>
                </div>

                <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 border rounded-md align-middle sm:px-6 lg:px-8">
                            <div className="overflow-hidden shadow-sm  sm:rounded-lg">
                                <table className="min-w-full divide-y  divide-gray-300 shadow-xl">
                                     <thead className="text-white  bg-[#0f172a]">
                                        <tr>

                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                                                #
                                            </th>
                                            <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                                                Name
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                                             Plan
                                            </th>
                                             <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                                             Group
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                                                Month
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                                                Amount
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                                                Created 
                                            </th>
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                                                Remark 
                                            </th>

                                            <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-6">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white ">
                                       
                                        {payouts?.length > 0 ? (
                                            payouts?.map((person, index) => (
                                                <tr
                                                    key={index}
                                                    className='hover:bg-gray-50'
                                                >
                                                    <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                                                        {index + 1}
                                                    </td>
                                                    <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                                                        {person?.customer?.name}
                                                    </td>
                                                    <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                                                        {person?.active_plan?.plan.name || ""}
                                                    </td>
                                                    <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                                                        {person?.active_plan?.group.group_name || ""}
                                                    </td>

                                                    <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                                                        {person?.month}
                                                    </td>
                                                    <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                                                        {person?.amount}
                                                    </td>
                                                    <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                                                        {person?.created_at ? new Date(person?.created_at).toLocaleDateString() : "-"}
                                                    </td>
                                                    <td className="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                                                        {person?.remark || "-"}
                                                    </td>
                                                    <td className="px-3 py-4  text-center text-sm font-medium whitespace-nowrap sm:pr-6 gap-2">
                                                        <button
                                                            type="button"
                                                            className=" rounded bg-white px-5 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                                                            onClick={() =>
                                                                handleClickForView(person)
                                                            }
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="rounded bg-white px-5 py-2 text-sm ml-2 font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                                                            onClick={() =>
                                                                Delete(person.id)
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6"> Data  Not Found</td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {paginationData && (
                <Pagination
                    links={paginationData?.links}
                    currentPage={paginationData?.current_page}
                    totalResults={paginationData?.total}
                    from={paginationData?.from}
                    to={paginationData?.to}
                    lastPage={paginationData?.last_page}
                    onPageChange={handlePageChange}
                />
            )}

            <Transition.Root show={payoutCreateOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={() => { }}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed z-10 inset-0 overflow-y-auto">
                        <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                                    <div>
                                        <PayoutCreate
                                            close={handleClose}
                                        // closeModal={closeModal}
                                        />
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {/*Modal Edit */}
            <Transition.Root show={payoutEditOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={() => { }}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed z-10 inset-0 overflow-y-auto">
                        <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                                    <div>
                                        <PayoutEdit
                                            close={handleClose}
                                            payoutId={payoutId}

                                        />
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            {/* Modal Edit*/}

            <Transition.Root show={payoutDelete} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed z-10 inset-0 overflow-y-auto"
                    onClose={() => setPayoutDelete(false)}
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>
                        <span
                            className="hidden sm:inline-block sm:align-middle sm:h-screen"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                                    <button
                                        type="button"
                                        className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        onClick={() => {
                                            setPayoutDelete(false);
                                            setDeleteMsg(
                                                "Are you sure you want to delete the Delete Payout ?"
                                            );
                                        }}
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="sm:flex sm:items-start">
                                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                        <ExclamationCircleIcon
                                            className="h-6 w-6 text-red-600"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg leading-6 font-medium text-gray-900"
                                        >
                                            Delete Payout
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">{deleteMsg}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                        onClick={handleClickForDelete}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                        onClick={() => setPayoutDelete(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>

        </div>
    )
}

export default PayoutList
